export default class SpendingPreferenceModal {
  constructor(data = {}) {
    this.propertyId = data.propertyId;
    this.estimatedAnnualSpend = data.estimatedAnnualSpend;
    this.doesOwnerKnowCost = data.doesOwnerKnowCost;
  }
}
